import api from './api';

const resource = 'Customer/';

export const list = async (query) => {
  return await api.get(resource + 'List' + query);
};

export const getById = async (query) => {
  return await api.get(resource + 'Get' + query);
};

export const counts = async (query = '') => {
  return await api.get(resource + 'Counts' + query);
};

const customerApi = { list, getById, counts };

export default customerApi;
